import { render, staticRenderFns } from "./DeleteSizeDialog.vue?vue&type=template&id=28632cda&scoped=true"
import script from "./DeleteSizeDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSizeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28632cda",
  null
  
)

export default component.exports